// Small styled confirm dialog (reuses the app's .modal styles). Resolves true on confirm.
export function confirmDialog(opts: { title: string; body: string; confirm: string; cancel?: string; emoji?: string; danger?: boolean }): Promise<boolean> {
  return new Promise((resolve) => {
    const bd = document.createElement("div");
    bd.className = "modal-backdrop";
    bd.innerHTML = `
      <div class="pr-dialog${opts.danger ? " is-danger" : ""}" role="alertdialog" aria-modal="true" aria-labelledby="pr-dlg-title">
        ${opts.emoji ? `<div class="pr-dialog-emoji">${opts.emoji}</div>` : ""}
        <div class="pr-dialog-title" id="pr-dlg-title"></div>
        <div class="pr-dialog-body"></div>
        <div class="pr-dialog-actions">
          <button class="pr-dialog-btn" data-r="0"></button>
          <button class="pr-dialog-btn is-primary" data-r="1"></button>
        </div>
      </div>`;
    bd.querySelector(".pr-dialog-title")!.textContent = opts.title;
    bd.querySelector(".pr-dialog-body")!.textContent = opts.body;
    bd.querySelector('[data-r="0"]')!.textContent = opts.cancel ?? "Cancel";
    bd.querySelector('[data-r="1"]')!.textContent = opts.confirm;

    const done = (v: boolean) => {
      window.removeEventListener("keydown", onKey, true);
      bd.remove();
      resolve(v);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        done(false);
      } else if (e.key === "Enter") {
        e.preventDefault();
        e.stopPropagation();
        done(true);
      }
    };
    bd.addEventListener("click", (e) => {
      const r = (e.target as HTMLElement).closest<HTMLElement>("[data-r]")?.dataset.r;
      if (r != null) done(r === "1");
      else if (e.target === bd) done(false);
    });
    window.addEventListener("keydown", onKey, true);
    document.body.appendChild(bd);
    bd.querySelector<HTMLElement>('[data-r="1"]')!.focus();
  });
}
